import TooltipContainer from "../../components/uiKits/tooltip";

const Tooltip = () => {
  return <TooltipContainer />;
};

export default Tooltip;
